module.exports = __webpack_public_path__ + "img/ascas com ascosporos.0fcf15b9.webp";